


























































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { IContract, IContractAttachment } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';

import { createFile, setErrorFromAxiosError } from '@/utils/helpers';

import ContractAddAttachmentsFormDialog from './ContractAddAttachmentsFormDialog.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

const baseMixins = mixins(authMixin, snackbar);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    addAttachmentsFormDialog: InstanceType<
      typeof ContractAddAttachmentsFormDialog
    >;
  };
}

export default baseMixins.extend({
  name: 'ContractAttachmentsListItem',
  components: {
    ConfirmationDialog
  },

  props: {
    contract: {
      type: Object as PropType<IContract>,
      required: true
    },

    attachment: {
      type: Object as PropType<IContractAttachment>,
      required: true
    }
  },

  data() {
    return {
      deleteAttachmentDialog: false,
      attachmentError: null as ISystemError | null
    };
  },

  methods: {
    ...mapActions({
      removeContractAttachment: 'contract/removeContractAttachment',
      downloadContractAttachment: 'contract/downloadContractAttachment'
    }),

    clearErrors() {
      this.attachmentError = null;
    },

    downloadAttachment(attachment: IContractAttachment) {
      this.clearErrors();
      this.downloadContractAttachment({
        contractId: this.contract.id,
        attachmentId: attachment.id
      })
        .then(data => {
          createFile(data, attachment.filename);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          const err = setErrorFromAxiosError(error);
          this.createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: err.detail || err.message,
            btnText: 'Close'
          });
        });
    },

    closeDeleteAttachmentDialog() {
      this.deleteAttachmentDialog = false;
    },

    removeAttachment(attachment: IContractAttachment) {
      this.clearErrors();
      this.removeContractAttachment({
        contractId: this.contract.id,
        attachmentId: attachment.id
      })
        .then(() => {
          this.closeDeleteAttachmentDialog();
          this.createSnack({
            color: '',
            right: true,
            useBtn: false,
            msg: 'Sucessfully removed attachment',
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.attachmentError = setErrorFromAxiosError(error);
        });
    }
  }
});
